import { QueryClient } from "@tanstack/react-query"

import type { TTFunction } from "$/i18n/i18n"

import {
    ECoachBreadcrumbVariant,
    type TCoachBreadcrumb
} from "@/3514/components/coach/breadcrumbs/coach.breadcrumbs.types"
import { EPath, ERoute } from "@/3514/constants"
import {
    coachDashboardAttendancesQueryPrefetcher,
    coachDashboardSessionsPrefetcher
} from "@/3514/pages/coach.dashboard"
import { coachingSessionsGroupQueryPrefetcher } from "@/3514/queries"

function renderCoachBreadcrumbs({
    groupId,
    sessionId,
    participantId,
    groupName,
    participantName,
    currentRoute,
    qc,
    t
}: {
    groupId: number | null
    sessionId: number | null
    participantId: number | null
    groupName: string | null
    participantName: string | null
    currentRoute: string
    qc: QueryClient
    t: TTFunction
}): Record<
    ERoute.Coach_Group | ERoute.Coach_GroupParticipant | ERoute.Coach_IndividualParticipant,
    TCoachBreadcrumb[]
> {
    return {
        [ERoute.Coach_Group]: [
            {
                isCurrent: false,
                label: t("common.dashboard"),
                url: EPath.Coach_Dashboard({ tab: "Sessions" }),
                variant: ECoachBreadcrumbVariant.Dashboard,
                async onHover(): Promise<void> {
                    await coachDashboardSessionsPrefetcher({ qc })
                    await coachDashboardAttendancesQueryPrefetcher({ qc })
                }
            },
            {
                isCurrent: currentRoute === ERoute.Coach_Group,
                label: groupName,
                url: EPath.Coach_Group({ groupId }, { sessionId, tab: "Sessions" }),
                variant: ECoachBreadcrumbVariant.Group
            }
        ],
        [ERoute.Coach_GroupParticipant]: [
            {
                isCurrent: false,
                label: t("common.dashboard"),
                url: EPath.Coach_Dashboard({ tab: "Sessions" }),
                variant: ECoachBreadcrumbVariant.Dashboard,
                async onHover(): Promise<void> {
                    await coachDashboardSessionsPrefetcher({ qc })
                    await coachDashboardAttendancesQueryPrefetcher({ qc })
                }
            },
            {
                isCurrent: false,
                label: groupName,
                url: EPath.Coach_Group({ groupId }, { tab: "Sessions" }),
                variant: ECoachBreadcrumbVariant.Group,
                async onHover(): Promise<void> {
                    await coachingSessionsGroupQueryPrefetcher({ qc }, { groupId })
                }
            },
            {
                isCurrent: currentRoute === ERoute.Coach_GroupParticipant,
                label: participantName,
                variant: ECoachBreadcrumbVariant.Group,
                url: EPath.Coach_GroupParticipant({ groupId, participantId }, { tab: "Sessions" })
            }
        ],
        [ERoute.Coach_IndividualParticipant]: [
            {
                isCurrent: false,
                label: t("common.dashboard"),
                url: EPath.Coach_Dashboard({ tab: "Sessions" }),
                variant: ECoachBreadcrumbVariant.Dashboard,
                async onHover(): Promise<void> {
                    await coachDashboardSessionsPrefetcher({ qc })
                    await coachDashboardAttendancesQueryPrefetcher({ qc })
                }
            },
            {
                isCurrent: currentRoute === ERoute.Coach_IndividualParticipant,
                label: participantName,
                variant: ECoachBreadcrumbVariant.Individual,
                url: EPath.Coach_IndividualParticipant({ participantId }, { tab: "Sessions" })
            }
        ]
    }
}

export default { renderCoachBreadcrumbs }
